import {Ref, ref} from 'vue'
import {get, post} from "@/api/phone";
import {FormInline} from "@/components/h_tb_header/tb_header_data";
import {ElLoading, ElMessage} from "element-plus";

interface Tb {
    "idCardNo": string,
    "phone": string,
    "price": string,
    "transAmt": string,
    "rePayTime": string | null,
    "payTime": string,
    "state": string,
    "type": string,
    "reqSeqId": string,
    "reqDate": string,
    "create_time": string,
    "description": string,
}

interface PageResult {
    total: number;
    pages: number;
    pageSize: number;
    list: Tb[];
}

export function useCheckPage(
    tableData: Ref<Tb[]>,
    callback?: () => void
) {

    const onSubmit = async () => {
        const loadingInstance = ElLoading.service({fullscreen: true})
        try {
            const response = await get<PageResult | Tb[]>('/user/reback/infoList');
            console.log('提交成功:', response.data);

            if (Array.isArray(response.data)) {
                tableData.value = response.data;
                callback?.();
            } else if (response.data && typeof response.data === 'object' && 'list' in response.data && Array.isArray(response.data.list)) {
                tableData.value = response.data.list;
                callback?.();
            } else {
                console.error('API 返回的数据格式异常:', response.data);
                ElMessage.error(response.msg)
                // callback?.();
            }
            loadingInstance.close();

        } catch (error) {
            console.error('提交失败:', error);
            loadingInstance.close();
        }
    };

    return {
        onSubmit,
    }
}
